import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-magento1-disable-builtin-reviews',
  template: require('./magento1_disable_builtin_reviews.component.html'),
  styles: [require('./magento1_disable_builtin_reviews.component.scss')]

})

export class Magento1DisableBuiltinReviewsComponent extends AccordionContentComponent {

}
